<template>
  <v-card>
    <v-card-title>
      <v-icon left>mdi-printer</v-icon>
      Print Jobs ({{ filteredPrintJobs.length }})
      <v-spacer></v-spacer>
      <v-chip v-if="search" x-small color="primary">
        gefiltert
      </v-chip>
    </v-card-title>

    <v-card-text style="max-height: 600px; overflow-y: auto;">
      <v-list dense>
        <v-list-item v-for="job in filteredPrintJobs" :key="job.id" class="mb-2">
          <v-list-item-content>
            <v-list-item-title>
              Order: {{ job.orderId }}
              <v-chip x-small :color="getStateColor(job.state)" class="ml-2">
                {{ $t(`printJob.states.${job.state}`) }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>
              <div><strong>Erstellt:</strong> {{ formatDate(job.created) }}</div>
              <div><strong>Menge:</strong> {{ job.quantity }}</div>
              <div v-if="job.assignedAt">
                <strong>Zugewiesen:</strong> {{ formatDate(job.assignedAt) }}
              </div>
              <div v-if="job.assignedTo">
                <strong>Gerät:</strong> {{ job.assignedTo }}
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="filteredPrintJobs.length === 0 && !loading">
          <v-list-item-content>
            <v-list-item-subtitle class="text-center">
              {{ search ? 'Keine passenden Print Jobs gefunden' : 'Keine Print Jobs vorhanden' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div v-if="loading" class="text-center pa-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PrintJobs',
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    headers: [
      { text: 'Order ID', value: 'orderId', sortable: true },
      { text: 'Erstellt', value: 'created', sortable: true },
      { text: 'Zugewiesen am', value: 'assignedAt', sortable: true },
      { text: 'Zugewiesen an', value: 'assignedTo', sortable: true },
      { text: 'Status', value: 'state', sortable: true },
      { text: 'Device ID', value: 'deviceId', sortable: true },
      { text: 'Menge', value: 'quantity', sortable: true }
    ]
  }),

  computed: {
    ...mapState('print', {
      printJobs: state => state.printJobs,
      loading: state => state.printJobsListener === null
    }),

    filteredPrintJobs() {
      if (!this.search || this.search.trim() === '') {
        return this.printJobs;
      }

      const searchTerm = this.search.toLowerCase();
      return this.printJobs.filter(job => {
        const orderId = job.orderId || '';
        return orderId.toLowerCase().includes(searchTerm);
      });
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return '-';

      // Handle Firestore Timestamp
      if (date.seconds) {
        return new Date(date.seconds * 1000).toLocaleString('de-DE');
      }

      // Handle JavaScript Date
      if (date instanceof Date) {
        return date.toLocaleString('de-DE');
      }

      // Handle timestamp number
      return new Date(date).toLocaleString('de-DE');
    },

    getStateColor(state) {
      const colors = {
        'new': 'blue',
        'assigned': 'orange',
        'processing': 'purple',
        'printed': 'green',
        'error': 'red',
        'cancelled': 'grey'
      };
      return colors[state] || 'grey';
    },

  }
}
</script>

<style scoped>
/* Optional: Custom styles */
</style>
